
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Job } from '@/domains/global/models'
import { viewOnly } from '@/domains/global/utils'

@Component
export default class JobDetails extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly job!: Job

  get isViewOnly() {
    return viewOnly(this.job)
  }

  get isCustomerJob () {
    return this.job.type === 'customer'
  }
}
